import { Language } from '../types/translation-types';
import { LanguageManagementRepository } from '../data/language-management-repository';
import { UpdateLanguageRequest } from '../types/language-management-types';

/**
 * Update Language Use Case
 * Updates an existing global language
 */
export class UpdateLanguageUseCase {
  constructor(private readonly repository: LanguageManagementRepository) {}

  async execute(languageId: number, data: UpdateLanguageRequest): Promise<Language> {
    return this.repository.updateLanguage(languageId, data);
  }
}
